// extracted by mini-css-extract-plugin
export var dropdownContainer = "_r8-0";
export var leftAlign = "_r8-4";
export var listItem = "_r8-2";
export var listItemWrapper = "_r8-1";
export var operationText = "_r8-3";